export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkScenarios: "nav-link-scenarios",
  linkBuilder: "nav-link-builder",
  linkContact: "nav-link-contact",
  langToggle: "nav-lang-toggle",
  ctaQuote: "nav-cta-quote",
};

export const HERO = {
  root: "hero-root",
  primaryCta: "hero-cta-primary",
  secondaryCta: "hero-cta-secondary",
  badge: "hero-badge",
};

export const SCENARIO = {
  card: (slug) => `scenario-card-${slug}`,
  cardCta: (slug) => `scenario-card-cta-${slug}`,
  detailRoot: "scenario-detail-root",
  detailAdd: "scenario-detail-add",
  detailBack: "scenario-detail-back",
};

export const BUILDER = {
  root: "builder-root",
  toggleScenario: (slug) => `builder-toggle-${slug}`,
  productItem: (slug) => `builder-product-${slug}`,
  clearBtn: "builder-clear-btn",
  submitBtn: "builder-submit-btn",
  nameInput: "builder-name-input",
  emailInput: "builder-email-input",
  phoneInput: "builder-phone-input",
  messageInput: "builder-message-input",
  productCount: "builder-product-count",
  scenarioCount: "builder-scenario-count",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  message: "contact-message",
  submit: "contact-submit",
};

export const HOME = { emergentLink: "emergent-link" };
